var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6102",
    "data-name": "Grupo 6102",
    transform: "translate(0 -1368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2311",
    "data-name": "Ret\\xE2ngulo 2311",
    width: 88,
    height: 88,
    rx: 20,
    transform: "translate(0 1368)",
    fill: "#ff947d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "library_add_check_50dp_5F6368",
    transform: "translate(17 1385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2312",
    "data-name": "Ret\\xE2ngulo 2312",
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6101",
    "data-name": "Grupo 6101",
    transform: "translate(8.25 8.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8565",
    "data-name": "Caminho 8565",
    d: "M5.75,38.75h27.5V41.5H5.75A2.758,2.758,0,0,1,3,38.75V11.25H5.75Zm35.75-33V30.5a2.758,2.758,0,0,1-2.75,2.75H14a2.758,2.758,0,0,1-2.75-2.75V5.75A2.758,2.758,0,0,1,14,3H38.75A2.758,2.758,0,0,1,41.5,5.75ZM36.11,12.3l-1.952-1.952L22.5,22l-3.905-3.877L16.64,20.077l5.83,5.83Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.181700bc.svg";
export { ForwardRef as ReactComponent };